module.exports = __webpack_public_path__ + "static/img/web_img_1.6b13e43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_img_1.png
// module id = ikk4
// module chunks = 0